import { z } from 'zod';
import {
  BookingOrigin,
  BookingState,
  JobListingState,
  BookingPaymentStatus,
} from './booking.enums';

export const CreateBookingRequestSchema = z.object({
  origin: z.enum(BookingOrigin),
  eventId: z.uuid().optional(),
  vendorId: z.uuid(),
  agreedAmount: z.number().min(0),
});

export const ConfirmBookingRequestSchema = z.object({
  escrowReference: z.string(),
});

export const BookingResponseSchema = z.object({
  id: z.uuid(),
  eventId: z.uuid().optional(),
  hostId: z.uuid(),
  vendorId: z.uuid(),
  quotedPrice: z.number(),
  currency: z.string(),
  scopeOfWork: z.record(z.string(), z.any()).optional(),
  requiredStartAt: z.iso.datetime(),
  requiredEndAt: z.iso.datetime(),
  bookingState: z.enum(BookingState),
  paymentStatus: z.enum(BookingPaymentStatus),
  escrowReference: z.string().optional(),
  completedAt: z.iso.datetime().optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const CreateJobListingRequestSchema = z.object({
  title: z.string().max(255),
  description: z.string(),
  requiredDate: z.iso.datetime(),
  estimatedDurationMinutes: z.number().int().positive().optional(),
  location: z.string(),
  budgetRangeMin: z.number().optional(),
  budgetRangeMax: z.number().optional(),
});

export const JobListingResponseSchema = z.object({
  id: z.uuid(),
  hostProfileId: z.uuid(),
  eventId: z.uuid().optional(),
  title: z.string(),
  description: z.string(),
  requiredDate: z.iso.datetime(),
  estimatedDurationMinutes: z.number().int().nullable().optional(),
  location: z.string(),
  budgetRangeMin: z.number().optional(),
  budgetRangeMax: z.number().optional(),
  state: z.enum(JobListingState),
  proposalCount: z.number(),
  createdAt: z.iso.datetime(),
});
